// deno-fmt-ignore-file
import { Guard } from '../../guard/index.mjs';
// ------------------------------------------------------------------
// Guard
// ------------------------------------------------------------------
/**
 * Returns true if the schema contains a valid const property
 * @specification Json Schema 7
 */
export function IsConst(value) {
    return Guard.HasPropertyKey(value, 'const');
}
